import { useFocusEffect } from "@react-navigation/native"
import { useCallback } from "react"

// Le quiz de fin de séance n'existe que sur la nouvelle interface élève. Sur l'ancienne, sa route
// rend l'accueil dès qu'elle est à l'écran : ouverte l'interrupteur éteint entre-temps, ou retrouvée
// en sortant du live (la pile garde une route dont le nom existe encore hors du live).
const OffLiveStudentSpaceOnly = ({ navigation }) => {
    useFocusEffect(
        useCallback(() => {
            if (navigation.canGoBack()) navigation.goBack()
            else navigation.replace("menu")
        }, [navigation])
    )
    return null
}

export default OffLiveStudentSpaceOnly
